import request from '../helpers/request';
import { Dispatch } from 'redux';
import {
    $FIXME,
    GET_DELIVERY_ADDRESS,
    GET_RINGROAD_AREAS,
    SAVE_DELIVERY_FAILURE,
    SAVE_DELIVERY_REQUEST,
    SAVE_DELIVERY_SUCCESS,
    SET_DELIVERY_ADDRESS
} from '../helpers/constants';
import { AxiosError, AxiosResponse } from 'axios';
import {
    IDeliveryAddress,
    IDeliveryAddressBody
} from '../interfaces/DeliveryAddress';
import { setErrors } from './errorActions';
import { store } from '../helpers/store';
import { getCarts } from './cartActions';

export const getDeliveryAddress = () => async (dispatch: $FIXME) => {
    return request.getDeliveryAddress().then((res: AxiosResponse) => {
        const resAddress: IDeliveryAddress[] = res.data;

        dispatch({ type: GET_DELIVERY_ADDRESS, payload: res.data });

        if (resAddress.length) {
            const selectedAddress: IDeliveryAddress | undefined =
                store.getState()?.deliveryAddress?.selectedDeliveryAddress;

            const primaryAddress = resAddress.find((addr) => addr.primary);

            const resSelectedAddress = resAddress.find(
                (addr) => addr._id === selectedAddress?._id
            );

            if (selectedAddress && resSelectedAddress) {
                dispatch(setDeliveryAddress(resSelectedAddress));
            } else if (primaryAddress) {
                dispatch(setDeliveryAddress(primaryAddress));
            } else {
                dispatch(setDeliveryAddress(resAddress[0]));
            }
        } else {
            dispatch(setDeliveryAddress());
        }

        return Promise.resolve();
    });
};

export const saveDeliveryAddress =
    (body: IDeliveryAddressBody) => async (dispatch: $FIXME) => {
        dispatch({ type: SAVE_DELIVERY_REQUEST });

        return request
            .saveDeliveryAddress(body)
            .then((res: AxiosResponse) => {
                dispatch({
                    type: SAVE_DELIVERY_SUCCESS,
                    payload: res.data.label
                });
                dispatch(getDeliveryAddress());

                return Promise.resolve();
            })
            .catch((err: AxiosError) => {
                dispatch({ type: SAVE_DELIVERY_FAILURE });
                dispatch(
                    setErrors(
                        err.response?.data.message ?? 'Something went wrong'
                    )
                );

                return Promise.reject();
            });
    };

export const deleteAddress = (id: string) => async (dispatch: $FIXME) => {
    request
        .deleteAddress(id)
        .then((res: AxiosResponse) => {
            dispatch(getDeliveryAddress());
        })
        .catch((err: AxiosError) => {
            dispatch(setErrors(err.response?.data.message));
        });
};

export const updateDeliveryAddress =
    (id: string, body: IDeliveryAddressBody, closeModal: VoidFunction) =>
    async (dispatch: $FIXME) => {
        dispatch({ type: SAVE_DELIVERY_REQUEST });

        request
            .updateAddress(id, body)
            .then((res: AxiosResponse) => {
                dispatch({ type: SAVE_DELIVERY_SUCCESS });
                dispatch(getDeliveryAddress());
                closeModal();
            })
            .catch((err: AxiosError) => {
                dispatch({ type: SAVE_DELIVERY_FAILURE });
                dispatch(
                    setErrors(
                        err.response?.data.message ?? 'Something went wrong'
                    )
                );
            });
    };

export const getRingroadAreas = () => async (dispatch: Dispatch) => {
    request.getRingroadAreas().then((res: AxiosResponse) => {
        dispatch({ type: GET_RINGROAD_AREAS, payload: res.data });
    });
};

export const setDeliveryAddress =
    (address?: IDeliveryAddress) => async (dispatch: $FIXME) => {
        dispatch({ type: SET_DELIVERY_ADDRESS, payload: address });

        dispatch(getCarts());
    };
